import type { InternalAxiosRequestConfig } from 'axios';
import axios, { AxiosError, AxiosRequestHeaders, AxiosResponse } from 'axios';
import { _setupStore } from '../state/setupStore';

const axiosInstance = axios.create();
const axiosInstanceErrorOn202 = axios.create();

const _requestConfig = (request: InternalAxiosRequestConfig<any>) => {
  if (request && request.url?.includes('/api')) {
    const headers: Record<string, string> = {};
    const stores = _setupStore.getState();
    headers['Authorization'] = `Bearer ${stores.token.value}`;

    if (stores.tenantId.value) {
      headers['X-TenantId'] = stores.tenantId.value;
    }
    request.headers = headers as AxiosRequestHeaders;
  }
  return request;
};

axiosInstance.interceptors.request.use(
  (request: InternalAxiosRequestConfig<any>) => {
    return _requestConfig(request);
  },
  // eslint-disable-next-line no-console
  (error: AxiosError) => console.warn(error),
);

axiosInstanceErrorOn202.interceptors.request.use(
  (request: InternalAxiosRequestConfig<any>) => {
    return _requestConfig(request);
  },
  (error: AxiosError) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => res.data,
  (error: AxiosError) => {
    // eslint-disable-next-line no-console
    return console.warn(error);
  },
);
axiosInstanceErrorOn202.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.status === 202) {
      const err: any = new Error('Retry');
      err.config = response.config; // axios-retry using this
      err.response = response; // optional, if you need for retry condition
      throw err;
    }
    return response;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

export { axiosInstanceErrorOn202 };
export default axiosInstance;
